module.exports = __webpack_public_path__ + "assets/f1f3119b9b2754d12c319da7e4a59e29.png";